import { createFileRoute } from "@tanstack/react-router";

import { InvestorPlatformPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/investor-platform")({
  component: InvestorPlatformPage,
});
